import * as dotPM from './dotPostMessage'

class PagePostMessager {
  constructor({ iframe, dotId, pageId }) {
    this.iframe = iframe
    this.dotId = dotId
    this.pageId = pageId
    this._listeners = {}
  }

  send(event, data) {
    dotPM.sendMessage(
      this.dotId,
      this.pageId,
      event,
      '*',
      data,
      this.iframe.contentWindow || this.iframe.contentDocument
    )
  }

  on(event, cb) {
    if (!this._listeners[event]) {
      dotPM.onMessage(this.dotId, this.pageId, event, (data) => {
        for (const fn of this._listeners[event]) {
          fn(data)
        }
      })
      this._listeners[event] = []
    }

    this._listeners[event].push(cb)
  }

  off(event, cb) {
    if (this._listeners[event])
      this._listeners[event] = this._listeners[event].filter((fn) => fn !== cb)
  }
}

export { PagePostMessager }
